import HeroAnimation, { selector as HeroAnimationSelector } from './hero-animation/script';

export default {
	[HeroAnimationSelector]: { Class: HeroAnimation }
};
